import {API_ENDPOINT_JSON} from './../config';

const bucketUrl = API_ENDPOINT_JSON?.s3_bucket;

/** Scope-1 EFDB sample, e.g. ipcc_Machine.xlsx / us_epa_Machine.xlsx */
export const getMachineSampleExcel = (
  scope1Db?: string | null
): string => {
  const dbName = typeof scope1Db === 'string' ? scope1Db.trim() : '';
  if (dbName) {
    return `${bucketUrl}/${dbName}_Machine.xlsx`;
  }

  return `${bucketUrl}/Machine.xlsx`;
};

/** Scope-1 EFDB sample, e.g. ipcc_Vehicle.xlsx / us_epa_Vehicle.xlsx */
export const getVehicleSampleExcel = (
  scope1Db?: string | null
): string => {
  const dbName = typeof scope1Db === 'string' ? scope1Db.trim() : '';
  if (dbName) {
    return `${bucketUrl}/${dbName}_Vehicle.xlsx`;
  }

  return `${bucketUrl}/Vehicle.xlsx`;
};

/** Scope-1 EFDB sample, e.g. ipcc_RefrigerantInfo.xlsx */
export const getRefrigerantSampleExcel = (
  scope1Db?: string | null
): string => {
  const dbName = typeof scope1Db === 'string' ? scope1Db.trim() : '';
  if (dbName) {
    return `${bucketUrl}/${dbName}_RefrigerantInfo.xlsx`;
  }

  return `${bucketUrl}/RefrigerantInfo.xlsx`;
};

export const SampleExcel = {
  facility: {
    default: `${bucketUrl}/Facility.xlsx`,
    hotel_and_lodge: `${bucketUrl}/FacilityHotel.csv`,
    restaurant: `${bucketUrl}/FacilityRestaurant.csv`
  },
  holding: `${bucketUrl}/Holdings.xlsx`,
  UpSupplier: `${bucketUrl}/Supplier_Upstream.xlsx`,
  DownSupplier: `${bucketUrl}/Supplier_Downstream.xlsx`,
  nonRenewable: `${bucketUrl}/electricitynonrenewable.xlsx`,
  renewable: `${bucketUrl}/electricityrenewable.xlsx`,
  fuelByMachine: `${bucketUrl}/Machine.xlsx`,
  fuelByRefri: `${bucketUrl}/RefrigerantInfo.xlsx`,
  fuelByVehicle: `${bucketUrl}/Vehicle.xlsx`,
  businessTravel: `${bucketUrl}/travelbusiness.xlsx`,
  waste: `${bucketUrl}/waste.xlsx`,
  empTravel: `${bucketUrl}/Employee_Travel.xlsx`,
  water: `${bucketUrl}/Water.xlsx`,
  SupplyUpstream: `${bucketUrl}/supplychainupstream.xlsx`,
  SupplyDownstream: `${bucketUrl}/supplychainupstream.xlsx`,
  CapitalGoodsAverage: {
    default: `${bucketUrl}/Capital_Goods_Average.xlsx`,
    hotel_and_lodge: `${bucketUrl}/capitalgoodaverageHotels%20&%20Lodging.xlsx`,
    restaurant: `${bucketUrl}/capitalgoodaverageRestaurants.xlsx`,
    footwear: `${bucketUrl}/capitalgoodaverageApparel, Accessories & Footwear.xlsx`
  },
  CapitalGoodsSpecific: `${bucketUrl}/capitalgoodsupplierspecific.xlsx`,
  AssetDownProperty: `${bucketUrl}/Asset_Property.xlsx`,
  AssetDownVehicle: `${bucketUrl}/Asset_Vehicle.xlsx`,
  AssetFranchise: `${bucketUrl}/Franchise.xlsx`,
  InvestmentEquity: `${bucketUrl}/investmentequity.xlsx`,
  InvestmentDebt: `${bucketUrl}/investmentdebt.xlsx`,
  InvestmentProjectFinance: `${bucketUrl}/investmentprojectfinance.xlsx`,
  add_userManagement: `${bucketUrl}/User_Management.xlsx`
};
